<template>
  <div class="p-3 bg-white">
    <shared-auto-call-system-delete-data
      @deleteSuccess="closePopup"
    ></shared-auto-call-system-delete-data>

    <div class="text-center">
      <vs-button id="deleteButton" class="m-2" color="primary" type="filled" @click.prevent="submitDelete">{{ $t('delete') }}</vs-button>
      <vs-button class="m-2 text-dark" color="transparent" type="filled" @click.prevent="closePopup">{{ $t('cancel') }}</vs-button>
    </div>

  </div>
</template>

<script>
import SharedAutoCallSystemDeleteData from '@/views/Shared/AutoCallSystem/DeleteData'
import { EventBus } from '@/../eventbus.js'

export default {
  name: 'Window.AutoCallSystem.DeleteData',
  components: {
    SharedAutoCallSystemDeleteData
  },
  methods: {
    submitDelete () {
      this.$windowOpenerHelper.notifyOpener('reload_auto_call_system_table')
      EventBus.$emit('initDeleteAutoCallSystemData')
    },
    closePopup () {
      window.close()
    }
  }
}
</script>

<style scoped>

</style>
